<div class="label truncate">{{ label() }}</div>
<div class="value">{{ value() }}</div>
